import { render, staticRenderFns } from "./AISuggestedCheckpointInstructions.vue?vue&type=template&id=428950aa&scoped=true"
import script from "./AISuggestedCheckpointInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./AISuggestedCheckpointInstructions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AISuggestedCheckpointInstructions.vue?vue&type=style&index=0&id=428950aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428950aa",
  null
  
)

export default component.exports